import { useCallback, useEffect, useMemo, useState } from "react";
import api from "services/baseService";
import { atom, useAtom } from "jotai";
import { atomWithStorage } from "jotai/utils";
import { useAppDispatch, useAppSelector } from "./redux";
import { actions as continuationOrderAction } from "store/continuationOrderCreate";
import { actions as newOrderAction } from "store/caseCreate";

export type ScannerResponse = {
  id: number;
  name: string;
  color: string;
  forCase: boolean;
  forOrder: boolean;
  forUser: boolean;
  type: string;
  created: string;
  modified: string;
  isEnabled: boolean;
};

const scannerListAtom = atom<string[]>([]);
const selectedScannerAtom = atomWithStorage<string | null>(
  "preferredScanner",
  null
);

const useGetScannerList = (newCase = false) => {
  const [list, setList] = useAtom(scannerListAtom);
  const [selectedScanner, setSelectedScanner] = useAtom(selectedScannerAtom); ///Todo: remove jotai for this just use redux + localstorage
  const [isError, setError] = useState<string | null>(null);
  const dispatch = useAppDispatch();
  const selectedScannerBrandRedux = useAppSelector(
    (state) => state[newCase ? "newCase" : "newOrder"].selectedScannerBrand
  );

  useEffect(() => {
    (async () => {
      if (list.length) return;

      try {
        const response = await api.get<{ result: { data: ScannerResponse[] } }>(
          "categories/filter"
        );
        const data = response.data.result.data;
        const result = data
          .filter((c) => c.forUser)
          .map((c) => c.name)
          .filter((name) => name.includes("IOS:"));
        setList(result);
      } catch (err) {
        console.error("useGetScannerList", err);
        setError(err instanceof Error ? err.message : String(err));
      }
    })();
  }, [list, setList]);

  useEffect(() => {
    if (selectedScannerBrandRedux !== selectedScanner) {
      dispatch(
        (newCase
          ? newOrderAction
          : continuationOrderAction
        ).setSelectedScannerBrand(selectedScanner)
      );
    }
  }, [selectedScanner, selectedScannerBrandRedux, newCase, dispatch]);

  const changeScanner = useCallback(
    (scanner: string) => {
      setSelectedScanner(scanner);
    },
    [setSelectedScanner]
  );

  const memoizedScannerList = useMemo(() => list, [list]);

  return {
    scannerlist: memoizedScannerList,
    isError,
    selectedScanner,
    setSelectedScanner: changeScanner,
  };
};

export default useGetScannerList;
